// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Pagos a receptores — colocated styles for the 3-tab page
   (Cola de pago · En proceso · Pagadas). The page shell (.page), tabs, toolbar,
   table (.tbl + .t-check), status text (.st) and buttons (.t-btn) come from the
   shared atoms / Table component. This file holds only what is unique to Pagos:
   the sticky paybar (cola running total + CTA), the comprobante link, and the
   competing-offers seal-check list inside the CheckoutModal (exp bulk pay). */

/* ── paybar — sticky bottom ribbon: selection breakdown + total + Pagar CTA ── */
.paybar {
  position: sticky;
  bottom: 16px;
  z-index: 30;
  display: flex;
  align-items: center;
  gap: 24px;
  margin-top: 16px;
  padding: 15px 20px;
  background: var(--surface);
  border: 1px solid var(--text);
  box-shadow: var(--shadow);
}
.paybar__sel {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}
.paybar__count {
  font-size: var(--fs-note);
  color: var(--text);
}
.paybar__count b {
  font-family: var(--mono);
  font-weight: 600;
}
.paybar__break {
  font-family: var(--mono);
  font-size: var(--fs-sm);
  color: var(--text-muted);
  letter-spacing: 0.02em;
}
.paybar__total {
  margin-left: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 1px;
}
.paybar__total-lbl {
  font-family: var(--mono);
  font-size: var(--fs-nano);
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--text-muted);
}
.paybar__total-val {
  font-family: var(--mono);
  font-size: var(--fs-figure);
  font-weight: 600;
  color: var(--text);
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.01em;
  line-height: 1.05;
}
.paybar__cta {
  flex: none;
}
@media (max-width: 640px) {
  .paybar {
    flex-wrap: wrap;
    gap: 12px;
    bottom: 0;
  }
  .paybar__total {
    margin-left: 0;
    align-items: flex-start;
  }
  .paybar__cta {
    width: 100%;
    justify-content: center;
  }
}

/* ── comprobante (boleta) link — Pagadas tab ──
   The Boleta link (\`.card__link\`): accent color, pointer, hover underline. Its
   only consumer today is Pagos, so the rule is defined here; if it gains other
   consumers it can move to a shared sheet. The download glyph rides inside it
   and inherits the accent color via currentColor. */
.card__link {
  font-size: var(--fs-2xs);
  color: var(--accent);
  text-decoration: none;
  cursor: pointer;
  display: inline-flex;
  gap: 5px;
  align-items: center;
}
.card__link:hover {
  text-decoration: underline;
}
.card__link--disabled {
  color: var(--text-muted);
  cursor: not-allowed;
  opacity: 0.55;
  pointer-events: none;
}
.pg-dl {
  width: 13px;
  height: 13px;
  stroke: currentColor;
  stroke-width: 1.7;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.pg-docs {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}
.pg-doc-cell {
  text-align: right;
}
.pg-docs__row {
  display: inline-flex;
  gap: 8px;
  align-items: center;
}
.pg-doc-cell .pg-docs__row {
  flex-wrap: wrap;
  justify-content: flex-end;
}

/* ── competing offers (inside the CheckoutModal, exp bulk pay) ──
   Seal-check selection (never a checkbox). */
.pg-ofertas {
  margin-bottom: 16px;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--border);
}
.pg-ofertas__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 7px;
}
.pg-ofertas__label {
  font-family: var(--mono);
  font-size: var(--fs-micro);
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--text-muted);
}
.pg-ofertas__count {
  font-family: var(--mono);
  font-size: var(--fs-sm);
  color: var(--text-secondary);
  padding: 1px 7px;
  border-radius: var(--radius-full);
  background: rgba(107, 114, 135, 0.14);
}
.pg-of {
  display: grid;
  grid-template-columns: 22px minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 9px 0;
  border: 0;
  border-bottom: 1px solid var(--border-soft);
  background: none;
  cursor: pointer;
  text-align: left;
  font-family: var(--sans);
}
.pg-of:last-child {
  border-bottom: 0;
}
.pg-of__seal {
  width: 18px;
  height: 18px;
  border-radius: 999px;
  border: 1.5px solid var(--border);
  display: grid;
  place-items: center;
  color: transparent;
  flex-shrink: 0;
}
.pg-of.is-on .pg-of__seal {
  background: var(--ink-dark);
  border-color: var(--ink-dark);
  color: var(--cream);
}
[data-theme='dark'] .pg-of.is-on .pg-of__seal {
  background: var(--cream);
  border-color: var(--cream);
  color: var(--ink-dark);
}
.pg-of__seal svg {
  width: 11px;
  height: 11px;
  stroke: currentColor;
  stroke-width: 2.2;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.pg-of__txt {
  min-width: 0;
}
.pg-of__n {
  display: block;
  font-size: var(--fs-2xs);
  color: var(--text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.pg-of__s {
  display: block;
  font-size: var(--fs-sm);
  color: var(--text-muted);
  font-family: var(--mono);
  margin-top: 1px;
}
.pg-of__amt {
  font-family: var(--mono);
  font-variant-numeric: tabular-nums;
  font-size: var(--fs-ui);
  color: var(--text);
  text-align: right;
}
`, "",{"version":3,"sources":["webpack://./src/pages/pagos/Pagos.css"],"names":[],"mappings":"AAAA;;;;;8EAK8E;;AAE9E,iFAAiF;AACjF;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,eAAe;IACf,SAAS;IACT,SAAS;EACX;EACA;IACE,cAAc;IACd,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;;;;oDAIoD;AACpD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,UAAU;EACV,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;6CAC6C;AAC7C;EACE,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,4BAA4B;EAC5B,gBAAgB;EAChB,iCAAiC;EACjC,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,cAAc;EACd,SAAS;EACT,2CAA2C;EAC3C,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,UAAU;EACV,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":["/* Pagos a receptores — colocated styles for the 3-tab page\n   (Cola de pago · En proceso · Pagadas). The page shell (.page), tabs, toolbar,\n   table (.tbl + .t-check), status text (.st) and buttons (.t-btn) come from the\n   shared atoms / Table component. This file holds only what is unique to Pagos:\n   the sticky paybar (cola running total + CTA), the comprobante link, and the\n   competing-offers seal-check list inside the CheckoutModal (exp bulk pay). */\n\n/* ── paybar — sticky bottom ribbon: selection breakdown + total + Pagar CTA ── */\n.paybar {\n  position: sticky;\n  bottom: 16px;\n  z-index: 30;\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  margin-top: 16px;\n  padding: 15px 20px;\n  background: var(--surface);\n  border: 1px solid var(--text);\n  box-shadow: var(--shadow);\n}\n.paybar__sel {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  min-width: 0;\n}\n.paybar__count {\n  font-size: var(--fs-note);\n  color: var(--text);\n}\n.paybar__count b {\n  font-family: var(--mono);\n  font-weight: 600;\n}\n.paybar__break {\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n  letter-spacing: 0.02em;\n}\n.paybar__total {\n  margin-left: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 1px;\n}\n.paybar__total-lbl {\n  font-family: var(--mono);\n  font-size: var(--fs-nano);\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n.paybar__total-val {\n  font-family: var(--mono);\n  font-size: var(--fs-figure);\n  font-weight: 600;\n  color: var(--text);\n  font-variant-numeric: tabular-nums;\n  letter-spacing: -0.01em;\n  line-height: 1.05;\n}\n.paybar__cta {\n  flex: none;\n}\n@media (max-width: 640px) {\n  .paybar {\n    flex-wrap: wrap;\n    gap: 12px;\n    bottom: 0;\n  }\n  .paybar__total {\n    margin-left: 0;\n    align-items: flex-start;\n  }\n  .paybar__cta {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n/* ── comprobante (boleta) link — Pagadas tab ──\n   The Boleta link (`.card__link`): accent color, pointer, hover underline. Its\n   only consumer today is Pagos, so the rule is defined here; if it gains other\n   consumers it can move to a shared sheet. The download glyph rides inside it\n   and inherits the accent color via currentColor. */\n.card__link {\n  font-size: var(--fs-2xs);\n  color: var(--accent);\n  text-decoration: none;\n  cursor: pointer;\n  display: inline-flex;\n  gap: 5px;\n  align-items: center;\n}\n.card__link:hover {\n  text-decoration: underline;\n}\n.card__link--disabled {\n  color: var(--text-muted);\n  cursor: not-allowed;\n  opacity: 0.55;\n  pointer-events: none;\n}\n.pg-dl {\n  width: 13px;\n  height: 13px;\n  stroke: currentColor;\n  stroke-width: 1.7;\n  fill: none;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.pg-docs {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 4px;\n}\n.pg-doc-cell {\n  text-align: right;\n}\n.pg-docs__row {\n  display: inline-flex;\n  gap: 8px;\n  align-items: center;\n}\n.pg-doc-cell .pg-docs__row {\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n/* ── competing offers (inside the CheckoutModal, exp bulk pay) ──\n   Seal-check selection (never a checkbox). */\n.pg-ofertas {\n  margin-bottom: 16px;\n  padding-bottom: 14px;\n  border-bottom: 1px solid var(--border);\n}\n.pg-ofertas__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 7px;\n}\n.pg-ofertas__label {\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n.pg-ofertas__count {\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  color: var(--text-secondary);\n  padding: 1px 7px;\n  border-radius: var(--radius-full);\n  background: rgba(107, 114, 135, 0.14);\n}\n.pg-of {\n  display: grid;\n  grid-template-columns: 22px minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 9px 0;\n  border: 0;\n  border-bottom: 1px solid var(--border-soft);\n  background: none;\n  cursor: pointer;\n  text-align: left;\n  font-family: var(--sans);\n}\n.pg-of:last-child {\n  border-bottom: 0;\n}\n.pg-of__seal {\n  width: 18px;\n  height: 18px;\n  border-radius: 999px;\n  border: 1.5px solid var(--border);\n  display: grid;\n  place-items: center;\n  color: transparent;\n  flex-shrink: 0;\n}\n.pg-of.is-on .pg-of__seal {\n  background: var(--ink-dark);\n  border-color: var(--ink-dark);\n  color: var(--cream);\n}\n[data-theme='dark'] .pg-of.is-on .pg-of__seal {\n  background: var(--cream);\n  border-color: var(--cream);\n  color: var(--ink-dark);\n}\n.pg-of__seal svg {\n  width: 11px;\n  height: 11px;\n  stroke: currentColor;\n  stroke-width: 2.2;\n  fill: none;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n.pg-of__txt {\n  min-width: 0;\n}\n.pg-of__n {\n  display: block;\n  font-size: var(--fs-2xs);\n  color: var(--text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.pg-of__s {\n  display: block;\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n  font-family: var(--mono);\n  margin-top: 1px;\n}\n.pg-of__amt {\n  font-family: var(--mono);\n  font-variant-numeric: tabular-nums;\n  font-size: var(--fs-ui);\n  color: var(--text);\n  text-align: right;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
